// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#0071ac"};